import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=f1169228&functional=true&"
import script from "./IconTrash.vue?vue&type=script&lang=js&"
export * from "./IconTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports